// extracted by mini-css-extract-plugin
export default {"tagsList":"tags_tagsList__6H4mN","tag":"tags_tag__mcgEy","selected":"tags_selected__tgBbI"};